import { Dialog } from "@dashboard/types";
import { stringifyQs } from "@dashboard/utils/urls";

export const homePath = "/";

/** Which card detail dialog is open. Kept in the URL so that coming back
 *  from an order or product page reopens it. */
export type HomeUrlDialog = "sales" | "out-of-stock";
export type HomeUrlQueryParams = Dialog<HomeUrlDialog>;

export const homeUrl = (params?: HomeUrlQueryParams) =>
  homePath + "?" + stringifyQs(params);
